
/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'file-plus': {
    width: 21,
    height: 26,
    viewBox: '0 0 21 26',
    data: '<path pid="0" d="M16.3 25.9H1.8c-1 0-1.7-.8-1.8-1.7V4.7c0-1 .8-1.8 1.7-1.8h7.7c.4 0 .9.2 1.2.5l6.9 7c.3.3.5.7.5 1.2v12.6c.1.9-.6 1.7-1.5 1.8l-.2-.1zm0-1.5c.1 0 .2-.1.2-.2V11.4l-6.9-7H1.8c-.1 0-.3.1-.3.3v19.5c0 .1.1.3.3.3l14.5-.1zM16.6 3V0H18v3h3v1.4h-3v3h-1.4v-3h-3V3h3z"/>'
  }
})
